/* eslint-disable */
<template>
  <!-- #################### FOOTER ############################## -->
  <div>
    <footer class="footer pt-5">
      <div class="container-fluid">
        <div class="container">
          <div class="row">
            <div class="col-md-4 pt-5">
              <h5>Meta</h5>
              <div class="underline-green mb-4"></div>
              <p>
                <i class="fa fa-chevron-right" aria-hidden="true"></i>Register
              </p>
              <p>
                <i class="fa fa-chevron-right" aria-hidden="true"></i>Log In
              </p>
            </div>
            <div class="col-md-4 pt-5">
              <h5>Tags</h5>
              <div class="underline-green mb-4"></div>
              <div class="footer_btn">
                <router-link
                  :to="{ name: 'Categorylist', params: { id: 'Bags' } }"
                  class="btn btn-outline-light"
                >Bags</router-link>
                <router-link
                  :to="{ name: 'Categorylist', params: { id: 'Belt' } }"
                  class="btn btn-outline-light"
                >Belts</router-link>
                <router-link
                  :to="{ name: 'Categorylist', params: { id: 'Jeans' } }"
                  class="btn btn-outline-light"
                >Jeans</router-link>
                <router-link
                  :to="{ name: 'Categorylist', params: { id: 'Shoes' } }"
                  class="btn btn-outline-light"
                >Shoes</router-link>
                <router-link
                  :to="{ name: 'Categorylist', params: { id: 'T-shirt' } }"
                  class="btn btn-outline-light"
                >T-Shirt</router-link>
                <router-link
                  :to="{ name: 'Categorylist', params: { id: 'Kids' } }"
                  class="btn btn-outline-light"
                >Kids wear</router-link>
              </div>
            </div>
            <div class="col-md-4 pt-5">
              <h5>About Us</h5>
              <div class="underline-green mb-4"></div>
              <div class="bout">
                <p>
                  MB Clothing is an E-commerce site with one main mission - to
                  show the love of the christ and help customers realise their
                  worth.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <section id="footer">
        <div class="container text-center">
          <p>&copy; {{getCurrentYear}} - MB Clothing | Designed By Victor Nwakwue</p>
        </div>
      </section>
    </footer>
  </div>
</template>
<script>
export default {
  name: "Footer",
  computed: {
    getCurrentYear() {
      let date = new Date();
      return date.getFullYear();
    }
  }
};
</script>

<style></style>
